import { Directive, inject, input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';

import {
  LoadingComponent,
  LoadingComponentMargin,
  LoadingComponentSize,
} from '../components/loading/loading.component';

@Directive({
  selector: '[isLoading]',
})
export class LoadingDirective implements OnChanges {
  isLoading = input<boolean | undefined>();
  isLoadingSize = input<LoadingComponentSize | undefined>();
  isLoadingMargin = input<LoadingComponentMargin | undefined>();

  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);

  ngOnChanges({ isLoading, isLoadingSize, isLoadingMargin }: SimpleChanges): void {
    this.viewContainer.clear();

    if (isLoading.currentValue) {
      const loadingRef = this.viewContainer.createComponent(LoadingComponent);

      if (isLoadingSize?.currentValue) {
        loadingRef.instance.size = isLoadingSize.currentValue;
      }
      if (isLoadingMargin?.currentValue) {
        loadingRef.instance.margin = isLoadingMargin.currentValue;
      }
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
